<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="RAW MATERIAL PRICE LIST" >
          <template slot="actions">
            <vs-button icon-pack="feather" icon="icon-arrow-left" @click="refreshData" class="mr-4" color="primary" type="border">
              Back to orders
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="raw_materials"
              sort
              :sst="true"
              class="table-dark-inverted table-auto vs-con-loading__container">
              <template slot="header">
                <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                          v-model="filters['search']"
                          class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
                <vs-button id="place_order"
                           @click.native="onClickCreateRmOrder"
                           :disabled="cartItems.length === 0"
                           icon-pack="feather" icon="icon-shopping-cart"
                           class="mr-12"
                           color="primary"
                           type="filled">
                  View cart ({{cartItems.length}} Items)
                </vs-button>
              </template>
              <template slot="thead">
                <vs-th sort-key="company_product_code">ITS CODE</vs-th>
                <vs-th sort-key="company_product_name">ITS NAME</vs-th>
                <vs-th>SUPPLIER</vs-th>
                <vs-th>RM ON ORDER</vs-th>
                <vs-th>UNIT</vs-th>
                <vs-th>MOQ</vs-th>
                <vs-th>PRICE (GBP)</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr
                  :state="data[indextr].errors.compulsory.length > 0 ? 'danger' : data[indextr].errors.warning.length > 0 ? 'warning' : null"
                  v-if="!isOnCart(data[indextr].id)" @click.native="onClickAddRm(data[indextr])" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].company_product_code">
                    {{ data[indextr].category.prefix}}-{{ data[indextr].company_product_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].company_product_name">
                    {{ data[indextr].company_product_name}}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier">
                    {{data[indextr].supplier}}
                  </vs-td>
                  
                  <vs-td :data="data[indextr].supplier">
                    {{data[indextr].pending_supplier_order_items.length < 1 ? 'No' : 'Yes'}}
                  </vs-td>

                  <vs-td :data="data[indextr].unit">
                      {{ data[indextr].unit }}
                  </vs-td>

                  <vs-td :data="data[indextr].min_order_quantity">
                      {{ data[indextr].min_order_quantity }}
                  </vs-td>

                  <vs-td :data="data[indextr].gbp_price">
                    {{ data[indextr].gbp_price }}
                  </vs-td>

                  <vs-td >
                    <div class="vx-row">
                      <vx-tooltip v-if="Number(data[indextr].gbp_price) !== 0 && data[indextr].errors.compulsory.length === 0" text="View & Add to Cart" position="top" class="mr-2">
                        <vs-button @click.stop="onClickAddRm(data[indextr])"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="View Raw Material" position="top" class="mr-2">
                        <vs-button @click.stop="onClickViewRawMaterial(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-external-link"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="data[indextr].errors.compulsory.length > 0 || data[indextr].errors.warning.length > 0"
                                  text="View Missing Elements" position="top" class="mr-2">
                        <vs-button @click.stop="onClickViewErrors(data[indextr].errors)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-alert-triangle"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip
                                  text="Show Existing Rm Orders" position="top" class="mr-2" v-if="data[indextr].pending_supplier_order_items.length > 0">
                        <vs-button @click.stop="onClickViewRmOrders(data[indextr].id)"
                                   size="small" color="success" type="border" icon-pack="feather" icon="icon-shopping-bag"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>

    <show-rm-price-pop-up ref="showRmPricePopUp"/>
    <create-rm-order-pop-up ref="createRmOrderPopUp"/>
    <rm-catalogue-error-pop-up ref="rmCatalogueErrorPopUp"/>
    <ShowExistingRmOrdersPopUp ref="showExistingRmOrdersPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  const InventoryRepository = RepositoryFactory.get('inventory')
  import ShowRmPricePopUp from '@/components/popups/inventory/rm-orders/ShowRmPricePopUp'
  import CreateRmOrderPopUp from '@/components/popups/inventory/rm-orders/CreateRmOrderPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";
  import RmCatalogueErrorPopUp from "@/components/popups/inventory/rm-orders/RmCatalogueErrorPopUp";
import ShowExistingRmOrdersPopUp from '@/components/popups/inventory/rm-orders/ShowExistingRmOrdersPopUp.vue';


  export default {
    name: 'RawMaterialPriceList',
    data () {
      return {
        raw_materials: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        perPage: defaultPagination,
        descriptionItems: perPageList,
        cartItems: []
      }
    },
    components: {
      'v-select': vSelect,
      ShowRmPricePopUp,
      CreateRmOrderPopUp,
      RmCatalogueErrorPopUp,
      ShowExistingRmOrdersPopUp,
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    methods: {
      async refreshData () {
        await this.fetchProjectBrief()
        this.$emit('back', '')
      },
      async onlyRefreshData() {
        await this.fetchProjectBrief()
      },
      async fetchProjectBrief() {
        this.$vs.loading()
        try {
          await this.getRmOrderCart()
          const {data} = await InventoryRepository.getListOfRmPrices(this.page, this.filterQuery, this.perPage)
          if(data.data.length === 0){
            this.raw_materials = []
          }else {
            this.raw_materials = data.data
            this.meta = data.meta
          }
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async getRmOrderCart() {
        const {data} = await InventoryRepository.getRmOrderCartList()
        this.cartItems = data.data
      },
      async onClickAddRm (data) {
        if (Number(data.gbp_price) !== 0 && data.errors.compulsory.length === 0) {
          await this.$refs.showRmPricePopUp.openPopup(data.id)
        } else {
          await this.$refs.rmCatalogueErrorPopUp.openPopUp(data.errors, 'RAW MATERIAL')
        }
      },
      async onClickCreateRmOrder () {
        await this.$refs.createRmOrderPopUp.openPopup()
      },

      async filterQueryUpdate (){
        await this.fetchProjectBrief()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchProjectBrief()
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      isOnCart: function (value) {
        return !!this.cartItems.find((n) => {
          return Number(n.supplier_raw_material_id) === Number(value)
        })
      },
      openAlert(color){
        this.colorAlert = color
        this.$vs.dialog({
          color:this.colorAlert,
          title: `Note`,
          acceptText: 'close',
          text: 'This RM cannot be ordered as there is no commercial information available',
        })
      },
      onClickViewErrors(errors) {
        this.$refs.rmCatalogueErrorPopUp.openPopUp(errors, 'RAW MATERIAL')
      },
      onClickViewRawMaterial(id) {
        let route = this.$router.resolve({path: `/pages/raw-materials/${id}`});
        window.open(route.href, '_blank');
      },
      onClickViewRmOrders(id){
        this.$refs.showExistingRmOrdersPopUp.openPopup(id)
      }
    },
    watch : {
      page(){
        this.fetchProjectBrief()
      },
      perPage() {
        this.fetchProjectBrief()
      }
    },
    computed: {

    },
    async mounted() {
      try {
        if (this.$route.query.open) {
          await this.$refs.showRmPricePopUp.openPopup(this.$route.query.open, this.$route.query.qty ? this.$route.query.qty : null)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
